<script>
export default {
  name: 'ContentLayout',
}
</script>

<template>
  <div :class="$style.containerOuter">
    <div :class="$style.containerOuterOverlay" />
    <div :class="$style.container">
      <BaseCard :class="$style.content">
        <slot />
      </BaseCard>
    </div>
  </div>
</template>

<style lang="scss" module>
@use '@design' as *;

.containerOuter {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  overflow-y: scroll;
}

.containerOuterOverlay {
  display: none;

  @media only screen and (min-width: $size-breakpoint-sm + 1px) {
    position: fixed;
    inset: 0;
    z-index: $layer-negative-z-index;
    display: block;
    background: rgb(255 255 255 / 30%);
    background-image: url('@assets/images/bg1_1.jpg');
    background-attachment: fixed;
    background-position: center;
  }
}

.container {
  width: 100%;
  max-width: $size-content-width-max;
  padding: $size-grid-padding $size-grid-padding 0;

  &::after {
    display: block;
    padding-bottom: $size-grid-padding;
    content: '';
  }

  @media only screen and (max-width: $size-breakpoint-sm) {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    padding: 0;
    margin: 0;
    border: none;

    &::after {
      display: none;
    }

    .content.content.content {
      flex-grow: 1;
      padding: $size-grid-padding;
      background-color: transparent;
      border-radius: 0;
    }
  }
}

.content.content.content {
  padding: $size-grid-padding * 2;
  background-color: transparent;
  box-shadow: none;
}
</style>
